import { useState } from 'react'
import ChangePasswordForm from '../ChangePasswordForm/ChangePasswordForm'
import { getLoginItem } from '../../utils'
import { SET_PASSWORD_MUTATION } from '../../graphql'
import { gql } from '@apollo/client'
import SuccessMessage from './SuccessMessage'

const SET_PASSWORD = gql(SET_PASSWORD_MUTATION)

export default function ChangePassword() {
  console.log('ChangePassword rendered')

  const title = 'Change Password'
  const [error, setError] = useState('')
  const [success, setSuccess] = useState(false)
  const userId = getLoginItem('id')

  function savePassword(newPassword) {
    window.apolloClient.mutate({ mutation: SET_PASSWORD, variables: { userId: userId, newPassword: newPassword } })
      .then(result => {
        setSuccess(true)
      })
      .catch(error => {
        setError(error.message)
      })
  }

  if (success) {
    return (
      <SuccessMessage
        title={title}
        text={'Your password has been successfully updated.'}
        handleOk={() => setSuccess(false)}
      />
    )
  }

  return (
    <div style={{ padding: '20px', backgroundColor: '#F0F2F5', height: '100%' }}>
      <span style={{ fontWeight: 'bold', fontSize: '1.25rem' }}>{title}</span>
      <ChangePasswordForm
        savePassword={savePassword}
        saveError={error}
        noHeader={true}
        cardMargin='10px 0'
        noCancelButton={true}
      />
    </div>
  )
}
